import type { PropTypes } from './TopUserCard.types';
import type { ReactElement } from 'react';

import { Badge, Box, Card, Flex, Heading, Text } from '@rango-dev/whale';
import { CircleDollarSign, CircleStar } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom';

import { Avatar } from '../../Profile/Avatar';
import { shortenUsername } from '../../Profile/Leaderboard/Leaderboard.helpers';
import {
  displayUsdValue,
  displayUserRank,
  displayUserRankOrdinal,
} from '../../Profile/ProfileSummary/ProfileSummary.helpers';

import styles from './TopUserCard.module.css';

const SCORE_ICON_SIZE = 24;

export function CompactTopUserCard(props: PropTypes): ReactElement {
  const { user, type } = props;

  return (
    <Card asChild variant="surface" size="1" className={styles.compactCard}>
      <Link
        className={`profile-page-public-leaderboard-top-user-link ${styles.compactLink}`}
        to={`../profile/${user.username}`}>
        <Flex direction="column" align="center" gap="2" px="2" py="4">
          <Box position="relative" width="64px" height="64px">
            <Avatar username={user.username} size="5" />
            {type === 'score' && (
              <Badge
                color="teal"
                variant="solid"
                radius="large"
                size="2"
                className={styles.compactLevelBadge}>
                {user.level}
              </Badge>
            )}
          </Box>
          <Heading size="5" weight="bold">
            {displayUserRankOrdinal(user.rank)}
          </Heading>
          <Text size="1" weight="medium" color="gray" className={styles.compactUsername}>
            {shortenUsername({ username: user.username })}
          </Text>
          <Flex align="center" gap="1">
            {type === 'referral' ? (
              <CircleDollarSign size={SCORE_ICON_SIZE} color="var(--red-9)" />
            ) : (
              <CircleStar size={SCORE_ICON_SIZE} color="var(--orange-8)" />
            )}
            <Text size="2" weight="medium">
              {type === 'referral'
                ? displayUsdValue(user.referralVolume)
                : displayUserRank(user.score)}
            </Text>
          </Flex>
        </Flex>
      </Link>
    </Card>
  );
}
